import { User } from "./user.model";

export enum DaisyAtlaOptions {
    A, B, C
}

export interface DaisyAtlaOption {
    id: number;
    userId: number;
    option: DaisyAtlaOptions;
    atlaQuantity?: string;
    bonusAtlaQuantity?: string;
    user: User;
}